module.exports = __webpack_public_path__ + "images/pro/ic-app-api-09028a270460786511a18a18ea6b65d3.png";